import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useSearchParams } from 'react-router-dom';
import { MerchantList } from './pages/MerchantList';
import { MerchantPage } from './pages/MerchantPage';
import { MerchantPageByLink } from './pages/MerchantPageByLink';
import './App.css';
import { useAppDispatch, useAppSelector } from './hooks/redux';
import { fetchCurrencies, fetchMerchants } from './store/ActionCreators';

function App() {
	const dispatch = useAppDispatch();
	const { currencies } = useAppSelector(state => state.currenciesSlice);
	const { merchants } = useAppSelector(state => state.merchantReducer);
	const location = useLocation();
	const [searchParams, setSearchParams] = useSearchParams();
	const lng = searchParams.get('lng');
	const { language } = useAppSelector(state => state.languageSlice);

	useEffect(() => {
		setSearchParams({'lng': language});
	}, [language]);

	function getDocHeight() {
		const doc = document;
		const body = doc.body,
			html = doc.documentElement;
		const height = Math.max(body.scrollHeight, body.offsetHeight,
			html.clientHeight, html.scrollHeight, html.offsetHeight);
		return height;
	}

	function sendDocHeightMsg() {
		const intervalPost = setInterval(function () {
			const ht = getDocHeight();
			if (ht !== 0) {
				parent.postMessage(JSON.stringify({
					'docHeight': ht
				}), '*');
				clearInterval(intervalPost);
			}
		}, 200);
	}

	useEffect(() => {
		if (currencies.length === 0) {
			dispatch(fetchCurrencies());
		}
		if (merchants.length === 0) {
			dispatch(fetchMerchants(lng));
		}
	}, []);

	useEffect(() => {
		dispatch(fetchMerchants(lng));
	}, [lng]);

	useEffect(() => {
		sendDocHeightMsg();
	}, [location]);

	return (
		<Routes>
			<Route index element={<MerchantList />} />
			<Route path="merchant/:id" element={<MerchantPage />} />
			<Route path="/:id" element={<MerchantPageByLink />} />
		</Routes>
	);
}

export default App;
